import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./reducers";
import { composeWithDevTools } from "redux-devtools-extension";

const initialState = {}
const enhancers = []
const middleware = [
  thunk
]
let meuCompose = compose;
if (process.env.NODE_ENV === "development") {
  meuCompose = composeWithDevTools;
}

const composedEnhancers = meuCompose(
  applyMiddleware(...middleware),
  ...enhancers
)

const store = createStore(
  rootReducer,
  initialState,
  composedEnhancers
);

export default store;




// WEBPACK FOOTER //
// ./src/store.js